import CTAButton from "@/components/base/CTAButton";

const ecosystemCards = [
  { icon: "ri-global-line", label: "Website", pos: "top-0 left-0", anim: "animate-float-slow" },
  { icon: "ri-dashboard-3-line", label: "Dashboard", pos: "top-2 right-0", anim: "animate-float-slower" },
  { icon: "ri-flow-chart", label: "Automation", pos: "top-[42%] -left-2", anim: "animate-float-slower" },
  { icon: "ri-line-chart-line", label: "Analytics", pos: "top-[42%] -right-2", anim: "animate-float-slow" },
  { icon: "ri-brain-line", label: "AI", pos: "bottom-0 left-4", anim: "animate-float-slow" },
  { icon: "ri-smartphone-line", label: "Mobile / Web App", pos: "bottom-0 right-4", anim: "animate-float-slower" },
];

export default function Hero() {
  return (
    <section className="relative overflow-hidden pt-16 md:pt-[72px]">
      {/* subtle background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-background-100 via-background-50 to-background-50" />
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-500/5 blur-3xl" />

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
        <div className="mx-auto max-w-[1280px] grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-10 items-center">
          {/* Left column */}
          <div className="w-full">
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
              <span className="w-6 h-px bg-primary-500"></span>
              DIGITAL SOLUTIONS • WEB • SOFTWARE • AUTOMATION
            </span>

            <h1 className="mt-5 font-heading text-4xl md:text-5xl lg:text-[3.4rem] font-bold leading-[1.08] tracking-tight text-foreground-950">
              We Build Digital Solutions That{" "}
              <span className="text-primary-600">Move Businesses Forward.</span>
            </h1>

            <p className="mt-6 text-lg text-foreground-600 leading-relaxed max-w-xl">
              EMCHON Technologies designs and builds websites, custom software
              and intelligent digital solutions that help businesses and
              organizations solve problems, improve operations and grow.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <CTAButton to="/contact" variant="primary" icon="ri-arrow-right-up-line">
                Start a Project
              </CTAButton>
              <CTAButton to="/solutions" variant="outline">
                Explore Our Solutions
              </CTAButton>
            </div>

            <p className="mt-8 text-sm text-foreground-500 tracking-wide">
              Strategy <span className="text-primary-500 mx-1">•</span> Design{" "}
              <span className="text-primary-500 mx-1">•</span> Development{" "}
              <span className="text-primary-500 mx-1">•</span> Technology
            </p>
          </div>

          {/* Right column — connected ecosystem visualization */}
          <div className="w-full flex items-center justify-center">
            <div className="relative w-full max-w-[520px] aspect-square">
              {/* soft red glow behind the orbit */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-[85%] h-[85%] rounded-full bg-primary-500/15 blur-3xl" />
              </div>

              {/* connection rings */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-[78%] h-[78%] rounded-full border-2 border-primary-500/50" />
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-[56%] h-[56%] rounded-full border-2 border-dashed border-primary-500/40" />
              </div>

              {/* core node */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative w-28 h-28 md:w-32 md:h-32">
                  <span className="absolute inset-0 rounded-full bg-primary-500/45 animate-[pulse-ring_2.5s_ease-out_infinite]" />
                  <span className="absolute -inset-4 rounded-full bg-primary-500/25 blur-xl" />
                  <div className="relative w-full h-full rounded-full bg-primary-500/30 flex flex-col items-center justify-center shadow-2xl">
                    <img className="w-10 h-10" src="/images/icon.png" alt="logo" />
                    <span className="mt-1 text-xs font-semibold text-foreground-950">
                      EMCHON
                    </span>
                  </div>
                </div>
              </div>

              {/* ecosystem cards */}
              {ecosystemCards.map((c) => (
                <div
                  key={c.label}
                  className={`absolute ${c.pos} ${c.anim} flex items-center gap-2 rounded-lg bg-background-50/80 backdrop-blur-md border border-background-200 px-3 py-2 shadow-sm`}
                >
                  <span className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
                    <i className={`${c.icon} text-base`}></i>
                  </span>
                  <span className="text-xs font-medium text-foreground-800 whitespace-nowrap">
                    {c.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}